import React, { Component } from "react";
import { Redirect, Link } from "react-router-dom";
import axios from "axios";
import { Container, Card, Button, Accordion, Modal } from "react-bootstrap";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import FavoriteIcon from "@mui/icons-material/Favorite";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import IconButton from "@mui/material/IconButton";
import TokenMessage from "../../Content/TokenMessage/TokenMessage";

import { checkCookie, getCookie } from "../../Utils/Utils";
import {
  AUCTION_API,
  AUCTION_BID_API,
  AUCTION_FAVORITE_API,
  AUCTION_NOTIFICATION,
  ENABLE_RESONATE_WEBSITE
} from "../../../constants/Constants";

import Header from "../../Content/Header/Header";
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import PersonIcon from '@mui/icons-material/Person';
import Countdown from 'react-countdown';

import AccordionCard from '@material-ui/core/Accordion';

import {
  AccordionSummary,
  AccordionDetails
} from "@material-ui/core";

require("./AuctionsPage.scss");

class AuctionsPage extends Component {
  componentDidMount() {
    // Restore scroll position if available
    
    const navType = performance.getEntriesByType("navigation")[0]?.type;
    const cameFromDetails = sessionStorage.getItem("cameFromDetails");
    if (navType === "reload" && !cameFromDetails) {
      sessionStorage.removeItem("auctionsPageScrollY");
      
      console.log("Page was reloaded — scroll position cleared");
    }

    sessionStorage.removeItem("cameFromDetails");
    const scrollY = sessionStorage.getItem("auctionsPageScrollY");

    if (!checkCookie("emailId") || !ENABLE_RESONATE_WEBSITE) {
      this.setState({ redirect: true });
    }

    axios.get(AUCTION_API + "/" + getCookie("userId")).then(response => {
      if (response.data.auctionNotificationStatus === undefined) {
        console.log("Auction notification not set");
        this.setState({showModal: true});
      }
      console.log(response.data);
      this.setState({ auctions: response.data.auctions }, () => {
          setTimeout(() => {
            if (scrollY && cameFromDetails) {
              window.scrollTo(0, parseInt(scrollY, 10));
            }
          }, 100);
      });
    });
  }

  componentWillUnmount() {
    // Save scroll position before leaving the page
    sessionStorage.setItem("auctionsPageScrollY", window.scrollY);
  }


  constructor(props) {
    super(props);

    this.state = {
      redirect: false,
      showModal: false,
      auctions: []
    };
  }

  handleAuctionNotification (notification) {
    let url = AUCTION_NOTIFICATION + getCookie("userId") + "/" + notification;
    console.log(url);
    axios
      .put(url)
      .then(response => {
        this.setState({showModal: false})
      });
  }

  handleFavorites(auction) {
    let auctionFavoriteItem = {};
    auctionFavoriteItem.auctionId = auction.auctionId;
    auctionFavoriteItem.userId = getCookie("userId");

    axios
      .post(AUCTION_FAVORITE_API, auctionFavoriteItem, {
        headers: {
          "Content-Type": "application/json"
        }
      })
      .then(response => {
        axios.get(AUCTION_API + "/" + getCookie("userId")).then(response => {
          this.setState({ auctions: response.data.auctions });
        });
      });
  }

  handlePlaceBid(auction) {
    
    let auctionBid = {};
    auctionBid.bidValue = 10;
    auctionBid.userId = getCookie("userId");
    auctionBid.auctionId = auction.auctionId;
    
    axios
      .post(AUCTION_BID_API, auctionBid, {
        headers: {
          "Content-Type": "application/json"
        }
      })
      .then(
        response => {
          axios.get(AUCTION_API + "/" + getCookie("userId")).then(response => {
            this.setState({ auctions: response.data.auctions });
          }); 
        },
        error => {
          console.log(error);
        }
      );
  }

  
  render() {
    if (this.state.redirect) {
      return <Redirect to="/" />;
    }
    const auctions = this.state.auctions;
    return (
      
      <Container className="auctions-page-container">
        <Modal className="email-verification" show={this.state.showModal}>
          <Modal.Header>
            <Modal.Title>Enable Notification</Modal.Title>
          </Modal.Header>
          <Modal.Body>
              Enable mobile notifications to get real-time updates when you’re outbid or when auctions you’re participating in are about to end.
          </Modal.Body>
          <Modal.Footer>
              <Button variant="primary" onClick={() => {
                  this.handleAuctionNotification(true);
                }}
                style={{ borderRadius: "0%" }}>
                Enable Notifications
              </Button>
              <Button variant="secondary" onClick={() => {
                  this.handleAuctionNotification(false);
                }}
                style={{ borderRadius: "0%" }}>
                Not Now
              </Button>
          </Modal.Footer>
        </Modal>
        <Header />
        <TokenMessage />
        <Container className="auction-container">
        <Accordion className="auction-accordian" defaultActiveKey={["0","1","2"]}>
        {Object.entries(auctions).map(([groupName, items], index) => (
            <Accordion.Item eventKey={String(index)} key={groupName}>
              <Accordion.Header>{groupName}</Accordion.Header>
              <Accordion.Body>
                {items.map((item) => (
                  <Card className="auction-card" key={item.auctionId}>
                    <Card.Img className="auction-image" src={item.imageName} ></Card.Img>
                    <Card.Body>
                    <AccordionCard>
                        <AccordionSummary className="auction-title">
                          {item.auctionName} <ExpandMoreIcon />
                        </AccordionSummary>
                        <AccordionDetails className="auction-description">
                          <p>{item.description}</p>
                          {item.link && (
                            <a
                              href={item.link}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              Product link →
                            </a>
                          )}
                        </AccordionDetails>
                      </AccordionCard>
                      <Card.Text className="auction-favourite">
                        <IconButton 
                          onClick={() => {
                            this.handleFavorites(item);
                          }}>
                            {item.favorite ? (
                              <FavoriteIcon className="icon-favorite" />
                            ) : (
                            <FavoriteBorderIcon />
                          )}
                        </IconButton>
                        <div className="auction-group">{item.auctionGroup}
                        {(item.running)? (<Countdown date= { Date.now() + item.remainingTime } renderer={({minutes, seconds, completed}) => completed? "": <span className="auction-countdown"> Ends in: {minutes}:{seconds}s</span>}/>) :""}
                        </div>
                        
                      </Card.Text>
                        <IconButton className="bidding-information"> 
                        {(item.active)? ((item.currentBidValue === 0 || item.currentBidValue === undefined)?(<div className="bid-details-start"><LocalOfferIcon color="warning"/> Starting Bid: {item.startingValue} tokens </div>): (<div className="bid-details-current"><LocalOfferIcon color="success"/> Current Bid: {item.currentBidValue} tokens </div>)):""}
                        
                        {
                          item.active &&
                          item.userBidValue !== undefined &&
                          item.currentBidValue !== undefined &&
                          (
                            item.currentBidValue > item.userBidValue ? (
                              <div className="bid-details-other">
                                <PersonIcon color="error" /> {item.bidderName} is leading
                              </div>
                            ) : (
                              item.userBidValue !== 0 &&
                              (<div className="bid-details-you">
                                <EmojiEventsIcon color="success" /> You're leading 
                              </div>)
                            )
                          )
                        }
                        </IconButton>
                        {(item.active)? ((item.currentBidValue > item.userBidValue || item.currentBidValue === 0 || item.userBidValue === 0 || item.currentBidValue === undefined || item.userBidValue === undefined)? <Button className="auction-bid-place-button" onClick={() => {
                          this.handlePlaceBid(item);
                        }}> Raise Bid by 10 tokens </Button>:""): <Button className="auction-bid-place-button-winner" disabled> Winner: {item.bidderName} </Button>}
                      <Link
                          to={`/auctiondetails/${item.auctionId}`}
                      >
                        <Button className="auction-bid-details-button">{(item.active? "Custom Bid / Additional Details ": "Bidding Details")}</Button>
                      </Link>
                      {(item.active)? "" :<Button className="auction-bid-close-button">Auction closed</Button>}
                    </Card.Body>
                  </Card>
              ))}
              </Accordion.Body>
            </Accordion.Item>
          ))}
        </Accordion>
        </Container>
      </Container>
    );
  }
}

export default AuctionsPage;
